/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import Loading from 'layoutComponents/Loading';

class EmailUpdater extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.setNewEmail = this
      .setNewEmail
      .bind(this);

    this.newEmailIsValid = this
      .newEmailIsValid
      .bind(this);

    this.currentEmailIsValid = this
      .currentEmailIsValid
      .bind(this);

    this.resetCustomerEmailChanges = this
      .resetCustomerEmailChanges
      .bind(this);

    this.setCustomerEmailEditModeTrue = this
      .setCustomerEmailEditModeTrue
      .bind(this);

    this.saveEmail = this
      .saveEmail
      .bind(this);

    if (props.isLoginEmail) {
      this.state =
      {
        newEmail: "newEmailLogin",
        email: "loginEmail"
      };
    } else {
      this.state =
      {
        newEmail: "newEmailContact",
        email: "contactEmail"
      };
    }
  }

  setNewEmail(e) {
    const { workOrderActions, orderId, isLoginEmail } = this.props;
    workOrderActions.setNewCustomerEmail(e.target.value, orderId, isLoginEmail);
  }

  newEmailIsValid() {
    const { customerDetail } = this.props;
    const newEmail = customerDetail.getIn([this.state.newEmail, 'value']);
    const re = /\S+@\S+\.\S+/;
    return re.test(newEmail);
  }
  currentEmailIsValid() {
    const { customerDetail } = this.props;
    const existingEmail = customerDetail.get(this.state.email);
    const re = /\S+@\S+\.\S+/;
    return re.test(existingEmail);
  }
  setCustomerEmailEditModeTrue() {
    const { workOrderActions, orderId, isLoginEmail } = this.props;
    workOrderActions.setCustomerEmailEditMode(true, orderId, isLoginEmail);
  }

  resetCustomerEmailChanges() {
    const { workOrderActions, orderId, isLoginEmail } = this.props;

    workOrderActions.resetCustomerEmailChanges(orderId, isLoginEmail);
    workOrderActions.setCustomerEmailEditMode(false, orderId, isLoginEmail);
  }

  saveEmail() {
    // eslint-disable-next-line react/prop-types
    const { workOrderActions, customerDetail, billingSystem, orderId, houseNumber } = this.props;
    const newEmail = customerDetail.getIn([this.state.newEmail, 'value']);
    let oldEmail = customerDetail.get(this.state.email);
    // prevention for multiple email addresses
    let request = null;

    workOrderActions.updateCustomerEmailMessageReset(orderId);

    if (newEmail && this.newEmailIsValid()) {
      if (this.props.isLoginEmail) {
        request = {
          userUid: customerDetail.get("userUid"),
          newLoginEmail: newEmail,
          ecid: customerDetail.getIn(['ecid'])
        };
      } else {
        const hasMultipleEmailAddresses = oldEmail && oldEmail.split(',').length > 1;
        if (hasMultipleEmailAddresses) {
          const tempOldAddress = oldEmail.split(',')[0].trim();
          oldEmail = tempOldAddress;
        }
        const accountNumber = customerDetail.getIn(['accountNumber']);
        request = {
          accountNumber: accountNumber,
          billingSystemType: billingSystem,
          emailAddress: newEmail,
          houseNumber: houseNumber,
          oldEmail: oldEmail,
          userUid: customerDetail.get("userUid"),
          ecid: customerDetail.getIn(['ecid'])
        };
      }
      workOrderActions.updateCustomerEmailStarted(request, orderId, this.props.isLoginEmail);
    }
  }

  render() {
    const { customerDetail } = this.props;

    const isError = customerDetail.getIn([this.state.newEmail, 'isError']);
    const errorMessage = customerDetail.getIn([this.state.newEmail, 'error']);

    let errorPanel = null;

    if (isError && errorMessage !== null) {
      errorPanel = (
        <div className="row">
          <div className="col s12">
            {errorMessage}
          </div>
        </div>
      );
    }

    let loader = null;
    const loading = customerDetail.getIn(['newEmail', 'loading']);
    const loadingFinished = customerDetail.getIn(['newEmail', 'loadingFinished']);

    if (loading === true && loadingFinished !== true) {
      loader = (
        <Loading
          message="Email update..."
          isLoading={loading}
        />
      );
    }

    let emailString = 'No Valid Email';

    if (customerDetail && this.currentEmailIsValid()) {
      emailString = customerDetail.getIn([this.state.email]);
    }

    // display one email, the last email (updated)
    const tempEmailString = emailString.split(',').length > 1;
    if (tempEmailString) {
      emailString = emailString.split(',')[0];
    }

    return (
      <div>
        <label>{"Contact Email: "}</label>
        <br />
        &nbsp;
        <span>{emailString}</span>
      </div>
    );
  }
}

EmailUpdater.propTypes = {
  orderId: PropTypes.string,
  workOrderActions: PropTypes.object,
  customerDetail: PropTypes.object,
  billingSystem: PropTypes.string,
  isLoginEmail: PropTypes.bool
};

export default EmailUpdater;



// WEBPACK FOOTER //
// ./src/components/account/EmailUpdater.js